import { escape } from 'lodash';

// order of these layers controls icon layers order as well as layer on/off toggle
export const mapLayers = [
    {
        name: 'Points of Interest',
        isClusterLayer: false,
        layers:
            [
                'poi_icon',
                'poi_circle'
            ],
        icons:
            [
                'poi_pin',
                'poi_pin_disabled'
            ]
    },
    {
        name: 'Recreation Areas',
        isClusterLayer: false,
        layers:
            [
                'gateway_icon',
                'gateway_circle'
            ],
        icons:
            [
                'recArea_pin',
                'recArea_pin_disabled'
            ]
    },
    {
        name: 'Day Use',
        isClusterLayer: false,
        layers:
            [
                'dayuse_icon',
                'dayuse_circle'
            ],
        icons:
            [
                'dayUse_pin',
                'dayUse_pin_disabled'
            ]
    },
    {
        name: 'Campgrounds',
        isClusterLayer: false,
        layers:
            [
                'campground_icon',
                'campground_circle'
            ],
        icons:
            [
                'camping_pin',
                'camping_pin_disabled'
            ]
    },
    {
        name: 'Permits',
        isClusterLayer: false,
        layers:
            [
                'permit_icon',
                'permit_circle'
            ],
        icons:
            [
                'permit_pin',
                'permit_pin_disabled'
            ]
    },
    {
        name: 'Tours',
        isClusterLayer: false,
        layers:
            [
                'ticketFacility_icon',
                'ticketFacility_circle',
                'tour_icon',
                'tour_circle'
            ],
        icons:
            [
                'ticketFacility_pin',
                'ticketFacility_pin_disabled',
                'tour_pin',
                'tour_pin_disabled'
            ]
    },
    {
        name: 'Activity Passes',
        isClusterLayer: false,
        layers:
            [
                'pass_icon',
                'pass_circle'
            ],
        icons:
            [
                'pass_pin',
                'pass_pin_disabled',
            ]
    },
    {
        name: 'Tree Permits',
        isClusterLayer: false,
        layers:
            [
                'permit_icon',
                'permit_circle'
            ],
        icons:
            [
                'permit_pin',
                'permit_pin_disabled'
            ]
    },
];

export const circleIconsColors = [
    ["camping_pin", "#3a86c6"],
    ["camping_pin_disabled", "#a5a5a7"],
    ["dayUse_pin", "#73d115"],
    ["gateway_pin", "#efaa00"],
    ["permit_pin", "#d06b43"],
    ["recArea_pin", "#efaa00"],
    ["poi_pin", "#34b795"],
    ["tour_pin", "#aa30bf"],
    ["ticketFacility_pin", "#aa30bf"],
    ["pass_pin", "#1F3A93"],
];

export const getTargetUri = (item) => {
    let targetUri;
    if (item.entity_type === "campground" && item.reservable) {
        targetUri = `/camping/campgrounds/${item.entity_id}`;
    }
    else if (item.entity_type === "permit") {
        targetUri = `/permits/${item.entity_id}`;
    }
    else if (item.entity_type === "vehiclepermit") {
        targetUri = `/vehiclepermits/${item.entity_id}`;
    }
    else if (item.entity_type === "tour") {
        targetUri = `/ticket/${item.parent_entity_id}/ticket/${item.entity_id}`;
    }
    else if (item.entity_type === "ticketfacility") {
        targetUri = `/ticket/facility/${item.entity_id}`;
    }
    else if (item.entity_type === "timedentry_tour") {
        targetUri = `/timed-entry/${item.parent_entity_id}/ticket/${item.entity_id}`;
    }
    else if (item.entity_type === "timedentry") {
        targetUri = `/timed-entry/${item.entity_id}`;
    }
    else if (item.entity_type === "recarea") {
        targetUri = `/camping/gateways/${item.entity_id}`;
    }
    else if (item.entity_type === "pass") {
        targetUri = `/sitepass/${item.park_pass_facility_id}`;
    }
    else if (item.entity_type === "activitypass") {
        targetUri = `/activitypass/${item.entity_id}`;
    }
    else if (item.entity_type === "treepermit") {
        targetUri = `/tree-permits/${item.entity_id}`;
    }
    else if (item.entity_type==="kb") {
        // ServiceNow knowledgebase
        targetUri = `https://recreationonestopprod.servicenowservices.com/external?id=kb_article&sys_id=${item.entity_id}`;
    }
    else if (item.entity_type==="cms") {
        // navigate to CMS article - the Drupal way
        const name = item.name.toLowerCase().split(" ").join("-");
        const type = item.content_type.toLowerCase().split("_").join("-");
        targetUri = `https://www.recreation.gov/articles/${type}/${name}/${item.entity_id}`;
    }
    else if (item.entity_type==="page") {
        // page
        targetUri = item.url;
    }
    else {
        targetUri = `/camping/poi/${item.entity_id}`;
    }

    return targetUri;
};

export const getMapIcon = (item) => {
    let mapIcon;
    if (item.entity_type === "campground") {
        mapIcon = "camping_pin";
        // use camping pin for all campgrounds but those with exclusively day-use campsites
        if (item.campsite_type_of_use) {
            mapIcon = "dayUse_pin";
            item.campsite_type_of_use.forEach((type) => {
                if (type !== "Day") {
                    mapIcon = "camping_pin";
                }
            });
        }
    }
    else if (item.entity_type === "permit") {
        mapIcon = "permit_pin";
    }
    else if (item.entity_type === "vehiclepermit") {
        mapIcon = "permit_pin";
    }
    else if (item.entity_type === "tour") {
        mapIcon = "tour_pin";
    }
    else if (item.entity_type === "ticketfacility") {
        mapIcon = "ticketFacility_pin";
    }
    else if (item.entity_type === "timedentry_tour") {
        mapIcon = "tour_pin";
    }
    else if (item.entity_type === "timedentry") {
        mapIcon = "ticketFacility_pin";
    }
    else if (item.entity_type === "recarea") {
        mapIcon = "recArea_pin";
    }
    else if (item.entity_type === "activitypass") {
        mapIcon = "pass_pin";
    }
    else if (item.entity_type === "treepermit") {
        mapIcon = "permit_pin";
    }
    else {
        mapIcon = "poi_pin";
    }
    if (item.availability === "unavailable") {
        mapIcon += "_disabled";
    }

    return mapIcon;
};

/**
 * Converts an array of locations to a GeoJSON and generates a description
 * property to use in the popup.
 */
export const locationListToGeoJson = (locationList) => {
    const geoJSON = {
        type: "FeatureCollection",
        features: []
    };

    const getCardImage = (media, addresses) => {
        const cardImage = {};
        if (media && media.length > 0) {
            cardImage.url = media[0].url;
            cardImage.title = media[0].title;
        }
        else {
            cardImage.url = `${process.env.CDN}/img/sample_image_small.jpg`;
            cardImage.title = "Placeholder";
        }

        if (addresses && addresses.length > 0) {
            cardImage.location = `${addresses[0].city}, ${addresses[0].address_state_code}`;
        }
        return cardImage;
    };

    const facilityPopupHTML = (cardImage, facilityName, availability, campsitesCount) => {
        const popupHTML = `
        <div class="map-popup">
            <div class="map-popup-image">
                <img src="${cardImage.url}" alt="${cardImage.title}" />
            </div>
            <div class="map-popup-message">
                <div class="map-popup-title">${facilityName}</div>
                ${cardImage.location ? `<p class="map-popup-text">${cardImage.location}</p>` : ''}
                <ul>
                    ${availability === 'unavailable' ? `<li>No availability for your dates</li>` : ''}
                    ${campsitesCount ? `<li>${campsitesCount} sites</li>` : ''}
                    <li class="rec-site-icons-wrap">
                        <span class="rec-site-icon">X</span>
                        <span class="rec-site-icon">X</span>
                        <span class="rec-site-icon">X</span>
                        <span class="rec-site-icon">X</span>
                        <span class="rec-site-icon">X</span>
                    </li>
                </ul>
            </div>
        </div>
      `;

        return popupHTML;
    };

    const recareaPopupHTML = (cardImage, facilityName) => {
        const popupHTML = `
        <div class="map-popup">
            <div class="map-popup-image">
                <img src="${cardImage.url}" alt="${cardImage.title}" />
            </div>
            <div class="map-popup-message">
                <div class="map-popup-title">${facilityName}</div>
                ${cardImage.location ? `<p class="map-popup-text">${cardImage.location}</p>` : ''}
            </div>
        </div>
      `;

        return popupHTML;
    };

    const mapFeature = (popupHTML, facilityName, entityType, facilityId, longitude, latitude, icon) => {
        const feature = {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: []
            },
            properties: {
                description: popupHTML,
                name: facilityName,
                entityId: facilityId,
                featureId: `${entityType}_${facilityId}`,
                icon
            }
        };

        feature.geometry.coordinates.push(longitude);
        feature.geometry.coordinates.push(latitude);

        return feature;
    };

    if (locationList && locationList.length > 0) {
        locationList.forEach((location) => {
            // if the object passed in is a facility/campground
            if (location.facility_longitude && location.facility_latitude) {
                const cardImage = getCardImage(location.media, location.addresses);

                const popupHTML = facilityPopupHTML(
                    cardImage,
                    location.facility_name,
                    location.availability,
                    location.campsites_count
                );

                const feature = mapFeature(
                    popupHTML,
                    location.facility_name,
                    location.entity_type,
                    location.facility_id,
                    location.facility_longitude,
                    location.facility_latitude,
                    "camping_pin"
                );

                geoJSON.features.push(feature);
            }
            // if the object passed in is a recarea
            else if (location.recarea_longitude && location.recarea_latitude) {
                const cardImage = getCardImage(location.media, location.addresses);

                const popupHTML = recareaPopupHTML(
                    cardImage,
                    location.recarea_name);

                const feature = mapFeature(
                    popupHTML,
                    location.recarea_name,
                    location.entity_type,
                    location.recarea_id,
                    location.recarea_longitude,
                    location.recarea_latitude,
                    "recArea_pin"
                );

                geoJSON.features.push(feature);
            }
        });
    }

    return geoJSON;
};

/**
 * Converts a campground JSON object with campsites into a geojson format.
 * @param {object} campground object with a campsite list.
 */
export function campsiteToGeoJson(campground) {
    const geoJSON = {
        type: "FeatureCollection",
        features: []
    };

    if (campground && campground.campsites && campground.campsites.length > 0) {
        campground.campsites.forEach((location) => {
            // Only create a feature point if it has a lat/lon.
            if (location.longitude && location.latitude) {
                const popupHTML = `
                <div class="map-popup">
                    <div class="map-popup-image">
                        <img src="${process.env.CDN}/img/sample_image_small.jpg" />
                    </div>
                    <div class="map-popup-message">
                        <div>
                            <div class="map-popup-title">Site ${escape(location.name)} - Loop ${escape(location.loop)}</div>
                            <p class="map-popup-text">${escape(location.type)}</p>
                        </div>
                        <div class="map-popup-button">
                            <a href="/campsites/${location.campsite_id}">
                                <button class="rec-button-primary" title="View Details" aria-label="Button Aria Label">View Details</button>
                            </a>
                        </div>
                    </div>
                </div>
                `;

                const feature = {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: []
                    },
                    properties: {
                        description: popupHTML,
                        name: location.name,
                        facilityId: location.facility_id,
                        campsiteId: location.campsite_id,
                        featureId: `${location.facility_id}_${location.campsite_id}`,
                        icon: "triangle"
                    }
                };

                const max = 0.0009;
                const min = 0.000001;
                const latitudeOffset = (Math.random() * (max - min)) + min;
                const longitudeOffset = (Math.random() * (max - min)) + min;

                const fakeLongitude = parseFloat(location.longitude) + latitudeOffset;
                const fakeLatitude = parseFloat(location.latitude) + longitudeOffset;

                feature.geometry.coordinates.push(fakeLongitude);
                feature.geometry.coordinates.push(fakeLatitude);

                geoJSON.features.push(feature);
            }
        });
    }

    return geoJSON;
}

export const getGeoJsonFromResultSet = (resultSet) => {
    if (resultSet && resultSet.campsites !== undefined) {
        return campsiteToGeoJson(resultSet);
    }

    return locationListToGeoJson(resultSet);
};
